<div class="card">
  <div class="card-body">
    <div class="card-header">
      <div class="icon-container">
        <rx-icon *ngIf="icon()" [name]="icon()" [fill]="'teal-dark'" size="lg" [attr.data-qa]="testIdPrefix() + 'card-box-title-icon'" />
      </div>
      <div class="title"  [attr.data-qa]="testIdPrefix() + 'card-box-title'">{{ title() }}</div>
    </div>
    <ng-container *ngIf="isLoading()">
      <div class="card-spinner"  [attr.data-qa]="testIdPrefix() + 'card-box-spinner'">
        <rx-applications-loading-spinner></rx-applications-loading-spinner>
      </div>
    </ng-container>
    <p *ngIf="hasData() && !isLoading()" class="card-no-data text-center"
       [attr.data-qa]="testIdPrefix() + 'card-box-no-data-text'">
      <img
        srcset="/assets/images/table/placeholder-table.png"
        src="/assets/images/table/placeholder-table.png"
        alt="No data available"
        height="60"
        width="auto"
        [attr.data-qa]="testIdPrefix() + 'card-box-no-data-img'"
      />
      {{ noDataMessage() }}
    </p>

    <ng-content></ng-content>

    <ng-container *ngIf="link() && showLink()">
      <a routerLink="{{ link() }}">
        <rx-button buttonClass="link" text="{{ linkText() }}"  [attr.data-qa]="testIdPrefix() + 'card-box-view-more-button'"></rx-button>
      </a>
    </ng-container>
  </div>
</div>
